import { Faqs, NavItemSnippet, NewCarBrands } from './shared'

export const newCarsSnippets: NavItemSnippet[] = [
  {
    heading: 'More new car offers',
    snippet: 'See the latest new car offers from Marshall Motor Group',
    linkText: 'Learn more',
    href: 'https://www.cinch.co.uk/new-car-offers',
    ariaLabel: 'Navigate to new car offers page',
    trackingAction: 'New car offers',
  },
  {
    heading: 'Land Rover offers',
    snippet:
      'Check out the latest offers on Range Rover, Defender and Discovery cars',
    linkText: 'Find out more',
    href: 'https://www.marshall.co.uk/land-rover/new-car-offers/',
    ariaLabel: 'Navigate to Land Rover offers page',
    trackingAction: 'Land Rover offers',
  },
  {
    heading: 'Why buy from Marshall?',
    snippet:
      '130+ stores, 25 automotive brands and over 115 years of expertise',
    linkText: 'Find out more',
    href: 'https://www.marshall.co.uk/new-cars/',
    ariaLabel: 'Navigate to sister site Marshall',
    trackingAction: 'go to marshall.co.uk',
    externalLink: true,
  },
]

export const newCarsFAQs: Faqs[] = [
  {
    label: 'Which brands does Marshall Motor Group work with?',
    href: 'https://help.cinch.co.uk/hc/en-gb/articles/27062225031709-Which-brands-does-Marshall-Motor-Group-work-with',
  },
]

export const newCarBrands: NewCarBrands[] = [
  {
    heading: 'New cars',
    cards: [
      {
        type: 'link',
        href: '/new-cars',
        image:
          'https://a.storyblok.com/f/143588/147x18/efe99dd8da/xpeng-logo-purple.png',
        alt: 'XPENG Cars',
      },
      {
        type: 'link',
        label: 'More brands coming soon',
      },
    ],
  },
]

export const discoverBrandsSnippets: NavItemSnippet[] = [
  {
    heading: 'What is XPENG?',
    snippet: 'Discover more about this exciting, emerging car brand',
    linkText: 'Find out more',
    href: '/xpeng',
    ariaLabel: 'Navigate to XPENG landing page',
    trackingAction: 'XPENG Landing Page',
  },
]
